import { status } from 'skin/event/status';

const del = (obj, ms, story, data, d, action) => {
	const key = story.s.msMod.table.product.row
	data.delRow(ms, 'product', key)
	return status.ignore
}

export default del
